import builtIn from "@/modules/locale/translations/built-in";
import { createI18n } from "vue-i18n";

const i18n = createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  messages: builtIn,
});

export default i18n;
